import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('customers/list', { params });
  },
  async add(params: any) {
    return axios.post('customers/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('customers/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('customers/detail', { params });
  },
  async delete(params: any) {
    return axios.post('customers/delete', qs.stringify(params));
  },
  async stadiums(params: any) {
    return axios.get('customers/stadiums', { params });
  },
  async admin(params: any) {
    return axios.get('customers/admin', { params });
  },
  async editadmin(params: any) {
    return axios.post('customers/editadmin', qs.stringify(params));
  },
  async selectdata(params: any) {
    return axios.get('customers/selectdata', { params });
  },
  async removeadmin(params: any) {
    return axios.post('customers/remove-admin', qs.stringify(params));
  }
};
